export default __webpack_public_path__ + "static/media/sp_edit_active.f3680646.svg";